import React, {ReactNode, useEffect, useState} from 'react';
import {TsrWithDropdownBox} from "./boxes/tsr-with-dropdown.box";
import {Select} from "../../../basic-ui-components/form/select.component";
import {TsrWithDropdownOptionSelectorBox} from "./boxes/tsr-with-dropdown-option-selector.box";
import {TsrWithDropdownMainTextBox} from "./boxes/tsr-with-dropdown-main-text.box";
import {TsrWithDropdownSelectorContainerBox} from "./boxes/tsr-with-dropdown-selector-container.box";
import {DISPLAY_MESSAGE_IDS} from "../../../../common/const/casinofied-analytics-consts";
import { TSR_TYPE} from '../../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/time-spent-reminder-options';
import {ModalDialogActionsComponent} from "../../modal-dialog/modal-dialog-actions.component";
import { DialogTextBox } from '../../modal-dialog/boxes/text/dialog-text.box';
import { AppIdentifiers, AreaType, ControlCenterOpenSource } from '@sparkware/uc-sdk-core';
import {ControlCenterDeeplink} from '@sparkware/uc-sdk-core';
import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {withServices} from "../../../react-hooks/with-services";
import {TimeSpentReminderWithDropdownComponentProps} from "./time-spent-reminder-with-dropdown.component.props";

enum UK_TSR_OPTIONS {
    UK_TSR_RESUME_GAME_OPT = "UK_TSR_RESUME_GAME_OPT",
    UK_TSR_CONTINUE_OPT = "UK_TSR_CONTINUE_OPT",
    UK_TSR_STOP_REMINDERS_OPT = "UK_TSR_STOP_REMINDERS_OPT",
    UK_TSR_REVIEW_REMINDERS_OPT = "UK_TSR_REVIEW_REMINDERS_OPT",
    UK_TSR_HISTORY_OPT = "UK_TSR_HISTORY_OPT",
    UK_TSR_CLOSE_GAME_OPT = "UK_TSR_CLOSE_GAME_OPT",
    UK_TSR_LOGOUT_OPT = "UK_TSR_LOGOUT_OPT"
}

const ELASTIC_CATEGORY: string = "Client_RealityCheck_Detail";

const TRACKING_UK_TSR_OPTION_NAMES: Record<UK_TSR_OPTIONS, string> = {
    [UK_TSR_OPTIONS.UK_TSR_RESUME_GAME_OPT]: "ResumeGame",
    [UK_TSR_OPTIONS.UK_TSR_CONTINUE_OPT]: "Continue",
    [UK_TSR_OPTIONS.UK_TSR_STOP_REMINDERS_OPT]: "StopReminders",
    [UK_TSR_OPTIONS.UK_TSR_REVIEW_REMINDERS_OPT]: "ReviewReminders",
    [UK_TSR_OPTIONS.UK_TSR_HISTORY_OPT]: "ViewHistory",
    [UK_TSR_OPTIONS.UK_TSR_CLOSE_GAME_OPT]: "CloseGame",
    [UK_TSR_OPTIONS.UK_TSR_LOGOUT_OPT]: "LogOut"
};

const TSR_OPTIONS_BY_TYPE: Record<TSR_TYPE, UK_TSR_OPTIONS[]> = {
    [TSR_TYPE.SESSION_TIMER]: [
        UK_TSR_OPTIONS.UK_TSR_CONTINUE_OPT,
        UK_TSR_OPTIONS.UK_TSR_REVIEW_REMINDERS_OPT,
        UK_TSR_OPTIONS.UK_TSR_HISTORY_OPT,
        UK_TSR_OPTIONS.UK_TSR_LOGOUT_OPT
    ],
    [TSR_TYPE.GAME_TIMER]: [
        UK_TSR_OPTIONS.UK_TSR_RESUME_GAME_OPT,
        UK_TSR_OPTIONS.UK_TSR_STOP_REMINDERS_OPT,
        UK_TSR_OPTIONS.UK_TSR_HISTORY_OPT,
        UK_TSR_OPTIONS.UK_TSR_CLOSE_GAME_OPT
    ]
};


interface ComponentBodyProps extends TimeSpentReminderWithDropdownComponentProps, ComponentServicesPick<'gameRunner' | 'appLauncher'>{

}

const ComponentBody: React.FC<ComponentBodyProps> = observer((props) => {
    const services = useServices();
    const [selectedOption, setSelectedOption] = useState(UK_TSR_OPTIONS.UK_TSR_RESUME_GAME_OPT);


    useEffect(() => {
        props.realityCheckAnalytics.sendUniqueAnalyticsEvent('tsr-messageDisplay', async (corrId) => {
            services.casinofiedAnalytics.messageDisplay({
                businessCorrelationID: corrId,
                displayMessageID: DISPLAY_MESSAGE_IDS.timeSpentReminder,
                displayMessageName: 'TimeSpentReminder'
            });
        });

    }, [services.casinofiedAnalytics, props.realityCheckAnalytics]);

    const updateSelection = (selection: UK_TSR_OPTIONS): void => {
        setSelectedOption(selection);
    };


    const renderPlayingTime = (): ReactNode => {
        const playingTimeWithoutUnits = services.sessionTimer.currentSessionTimer.toHoursAndMinutesString();
        //Temporary hack to also display 'h' and 'm', should probably modify TimeSpan class to support this
        const playingTime = `${playingTimeWithoutUnits.substring(0, 2)}h${playingTimeWithoutUnits.substring(2)}m`;
        return (
            <TsrWithDropdownMainTextBox className={"cy-uk-tsr-main-text-box"}>
                <span>{services.translation.translate('TSR_SESSION_TIME_TEXT')}</span>
                <span>{playingTime}</span>
            </TsrWithDropdownMainTextBox>
        );
    };

    const renderSelect = (): ReactNode => {
        return (
            <TsrWithDropdownOptionSelectorBox>
                <Select
                    className={'cy-drop-down-box'}
                    value={selectedOption}
                    onChange={e => updateSelection(e.target.value as UK_TSR_OPTIONS)}
                    width="100%"
                >
                    {Object.values(TSR_OPTIONS_BY_TYPE[props.timerType]).map(tsrOption =>
                        <option value={tsrOption}
                                key={tsrOption}>
                            {services.translation.translate(tsrOption)}
                        </option>
                    )}
                </Select>
            </TsrWithDropdownOptionSelectorBox>
        );
    };

    const renderSelectorContainer = (): ReactNode => {
        return (
            <TsrWithDropdownSelectorContainerBox className={'cy-reality-check-options'}>
                <DialogTextBox>{services.translation.translate('TSR_SUBTEXT')}</DialogTextBox>
                {renderSelect()}
                <ModalDialogActionsComponent primaryAction={{
                    text: services.translation.translate('TSR_CONFIRM'),
                    onClick: executeAction
                }} />
            </TsrWithDropdownSelectorContainerBox>
        );
    };




    const executeAction = async () => {

        const closeCurrentGame = async () => {
            await (await services.gameRunner).closeCurrentGame({
                shouldSuggestNextGame: false
            });
        }

        sendActionDataTracking();
        switch (selectedOption) {
            case UK_TSR_OPTIONS.UK_TSR_RESUME_GAME_OPT:
            case UK_TSR_OPTIONS.UK_TSR_CONTINUE_OPT:
                closeDialogBox();
                break;
            case UK_TSR_OPTIONS.UK_TSR_HISTORY_OPT:
                closeDialogBox();
                services.gameRouteHandler.redirectToHistory();
                break;
            case UK_TSR_OPTIONS.UK_TSR_CLOSE_GAME_OPT:
                closeDialogBox();
                closeCurrentGame();
                break;
            case UK_TSR_OPTIONS.UK_TSR_LOGOUT_OPT:
                closeDialogBox();
                await closeCurrentGame();
                services.user.logout();
                break;
            case UK_TSR_OPTIONS.UK_TSR_REVIEW_REMINDERS_OPT:
                closeDialogBox();
                closeCurrentGame();
                onReviewReminders();

                break;
            case UK_TSR_OPTIONS.UK_TSR_STOP_REMINDERS_OPT:
                onStopFurtherReminders();
                closeDialogBox();
                break;
        }
    };

    const onReviewReminders = async () => {
        const businessCorrelationID = await props.realityCheckAnalytics.getBusinessCorrelationId();
        await props.appLauncher.openControlCenterFull({
            businessCorrelationID: businessCorrelationID,
            channel: {
                area: AreaType.button,
                element: UK_TSR_OPTIONS.UK_TSR_REVIEW_REMINDERS_OPT,
                source: AppIdentifiers.CasinoClient
            },
            appSpecificParameters: {
                deeplink: ControlCenterDeeplink.TimeSpentReminderPage,
                source: ControlCenterOpenSource.Lobby
            }
        });
    }
    
    const onStopFurtherReminders = async ()  => {
        if (props.timerType === TSR_TYPE.GAME_TIMER) {
            await services.regulation.current.disableRealityCheck();
        }
    };

    const closeDialogBox = (): void => {
        props.dialogHandler.close();
    };

    const sendActionDataTracking = async () => {
        const action = TRACKING_UK_TSR_OPTION_NAMES[selectedOption];

        await props.realityCheckAnalytics.sendUniqueAnalyticsEvent('tsr-messageActionTaken', async (corrId) => {
            sendActionDataToElastic(action);
            services.casinofiedAnalytics.messageActionTaken({
                actionType: action,
                businessCorrelationID: corrId
            });
        });
    };

    const sendActionDataToElastic = (action: string): void => {
        const logger = services.analytics.getLogger({
            CGPEventCategory: ELASTIC_CATEGORY,
            CGPEventAction: action
        });

        logger.setTarget('casino-realityCheck');
        logger.info();
    };

    return (
        <TsrWithDropdownBox>
            {renderPlayingTime()}
            {renderSelectorContainer()}
        </TsrWithDropdownBox>
    );

})


export const TimeSpentReminderWithDropdownComponent = withServices(ComponentBody, ["gameRunner", 'appLauncher']);